<template>
  <div class="default-vue">
    <div class="rounded-s p-x-s blog-speaker-display speaker-box--style" :style="{'background-color': backgroundcolor, 'background-image': 'url(' + backgroundimage + ')' }">
      <p v-if="title" class="font-weight-bolder h4-blog" :style="{'color': textcolor}">{{title}}</p>
      <div v-if="result && result.experts && result.experts.Experts && !error && !loading"
        class="speakers-info-container">
        <div v-for="anExpert in sortExpertsInSameOrder(result.experts.Experts)" :key="anExpert._id" class="each-speaker-box p-x-s">
          <a target="_blank" :href="'/speaker/' + anExpert.slug">
            <img
             v-if="anExpert.avatarSquareSmall && anExpert.avatarSquareSmall.x && anExpert.avatarSquareSmall.x !== 'null'"  :src="anExpert.avatarSquareSmall.x" alt="" width="500" height="350" style="opacity: 1;">
            <img v-else
              src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/avatarSquareLarge_xx_mustermann_max_ek_1558018462305.png"
              alt=""> </a>
          <div :class="{'align-expert-name': !anExpert.company}">
            <a v-if="anExpert.forename || anExpert.surname" target="_blank" :href="'/speaker/' + anExpert.slug" :style="{'color': textcolor}">
              <span class="font-weight-bolder"> {{anExpert.forename}}&nbsp;{{anExpert.surname}}</span>
            </a>
            <p v-if="anExpert.company" class="gdlr-speaker-position">{{anExpert.company}}</p>
          </div>
        </div>
      </div>
      <div v-if="error">
        Something went wrong
      </div>
      <div v-if="loading">LOADING</div>
    </div>
  </div>
</template>

<script>
import queryAndMutaionService from '@/services/queryAndMutaionService'

export default {
  name: 'SpeakersInBlog',
  props: {
     settingsPerm: Object
  },
   data() {
     return {
            Speakers: false,
            result:null,
            loading:false, 
            error:true,
            title: this.settingsPerm.title,
            slugs: this.settingsPerm.speakerslug,
            backgroundimage: this.settingsPerm.backgroundimage,
            backgroundcolor: this.settingsPerm.backgroundcolor,
            pagecaption: this.settingsPerm.pagecaption,
            textcolor: this.settingsPerm.textcolor
        }
    },
  mounted() {
  },
  created() {
    if (this.slugs && this.slugs.length > 3) {
        this.slugs = this.slugs.split(",").slice(0, 3);
      }else{
        this.slugs = this.slugs.split(",");
      }
    let concordData = queryAndMutaionService.getSpeakersForBlog(this.slugs);
         if (concordData && concordData.result) {
            this.result = concordData.result;
        }
        if (concordData && concordData.loading) {
            this.loading = concordData.loading;
        }
        if (concordData && concordData.error) {
            this.error = concordData.error;
        }
  },
  methods: {
    sortExpertsInSameOrder(experts){
      let sortedExperts = [];
      let incomingSlugsArray =  this.settingsPerm.speakerslug.split(",");
      if (experts && experts.length) {
        experts.forEach(expert => {
          if (incomingSlugsArray.includes(expert.slug)) {
              let indexOfThisExpert = incomingSlugsArray.indexOf(expert.slug);
              if (indexOfThisExpert > 0) {
                sortedExperts.splice(indexOfThisExpert,0,expert);
              }else if(indexOfThisExpert == 0){
                sortedExperts.unshift(expert);
              }
          }

        });
      }
      return sortedExperts;
    },
  },
}
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .blog-speaker-display{
    padding: 20px 25px;
    background-size: cover;
  }
  .align-expert-name{
    padding-bottom: 25px;
  }
</style>
